import { DataBean } from "../DataBean";

export class ImportResourceCost extends DataBean {


    public async importResourceCost(filename: any, directory: any, dataStore: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importResourceCost_String_String_String", [filename,directory,dataStore]);
    }


   

   

 
}